import Rollbar from 'rollbar';
import {
    Injectable,
    Inject,
    InjectionToken,
    ErrorHandler
} from '@angular/core';
import { environment } from 'environments/environment';

declare const FS;

const rollbarConfig = {
  accessToken: environment.ROLLBAR_API_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  verbose: true,
  server: {
    root: 'webpack:///'
  },
  payload: {
    environment: environment.environment === 'LIVE' ? 'production' : environment.environment,
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: environment.GIT_COMMIT,
        guess_uncaught_frames: true
      }
    },
  },
  ignoredMessages: [
    'BORROWER NOT FOUND',
    'BAD REQUEST',
    'FORBIDDEN'
  ],
  checkIgnore: (isUncaught, args, payload) => {
    if (payload.request.url.includes('/token?e=pipelineguy@lendio.com&t=hulk')) {
      return true;
    }
    return false;
  },
  onSendCallback: (isUncaught, args, payload) => {
    try {
      payload.fullstorySessionUrl = FS.getCurrentSessionURL(true) || null;
    } catch (e) {
      return; // do nothing
    }
  }
};

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class RollbarErrorHandler implements ErrorHandler {

  constructor(
    @Inject(RollbarService) private rollbar: Rollbar
  ) {}

  handleError(err: any): void {
    const type = err.name || 'Untyped Error';
    const message = this.resolveMessage(err);
    const data = err;

    if (message.includes('ChunkLoadError')) {
      window.location.reload();
      return;
    }

    this.log(`Uncaught ${type}: ${message}`, data);
  }

  private log(message: string, data: any): void {
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (environment.environment !== 'dev' && !isMobile) {
      this.rollbar.error(message, data);
    } else {
      console.error(message, data);
    }
  }

  private resolveMessage(err: any): string {
    if (typeof err === 'string') {
      return err;
    }
    const fallback = this.getErrorFallback(err);
    return err.message || `with no message${fallback}`;
  }

  private getErrorFallback(err: any): string {
    const url = err.target?.__rollbar_event?.body?.url;
    return err.file
      ? ` from file: ${err.file}`
      : url
        ? ` from request to URL: ${url}`
        : '';
  }
}

export function rollbarFactory() {
    return new Rollbar(rollbarConfig);
}
